<script lang="ts" setup>
import { SemboSuitcaseIllustration, AppSvgIcon } from '@libs/ui';

interface flightPlusHotelBanner {
  hideBanner: boolean;
}

const props = defineProps<flightPlusHotelBanner>();
</script>

<template>
  <div class="flight-plus-hotel-banner">
    <div class="banner-content">
      <div v-if="!props.hideBanner" class="illustration-container">
        <SemboSuitcaseIllustration />
      </div>

      <div class="text-content">
        <div class="banner-header">
          <h3 class="banner-title">
            {{ $t('flight_plus_hotel_banner.title') }}
          </h3>
          <p class="banner-subtitle">
            {{ $t('flight_plus_hotel_banner.subtitle') }}
          </p>
        </div>

        <div class="benefits">
          <div class="benefit-item">
            <AppSvgIcon class="benefit-icon" size="18" name="check" />
            <div class="benefit">
              <span class="benefit-title">
                {{ $t('flight_plus_hotel_banner.benefits.better_rates.title') }}
              </span>
              <span class="benefit-description">
                {{
                  $t(
                    'flight_plus_hotel_banner.benefits.better_rates.description'
                  )
                }}
              </span>
            </div>
          </div>
          <div class="benefit-item">
            <AppSvgIcon class="benefit-icon" size="18" name="check" />
            <div class="benefit">
              <span class="benefit-title">
                {{
                  $t('flight_plus_hotel_banner.benefits.full_protection.title')
                }}
              </span>
              <span class="benefit-description">
                {{
                  $t(
                    'flight_plus_hotel_banner.benefits.full_protection.description'
                  )
                }}
              </span>
            </div>
          </div>
          <div class="benefit-item">
            <AppSvgIcon class="benefit-icon" size="18" name="check" />
            <div class="benefit">
              <span class="benefit-title">
                {{
                  $t('flight_plus_hotel_banner.benefits.earn_free_nights.title')
                }}
              </span>
              <span class="benefit-description">
                {{
                  $t(
                    'flight_plus_hotel_banner.benefits.earn_free_nights.description'
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.flight-plus-hotel-banner {
  display: flex;
  padding: var(--spacing-24);
  border-radius: var(--spacing-12);
  border: 1px solid var(--color-neutral-20);
  background-color: var(--color-information-light);
  color: var(--color-neutral-70);
  .banner-content {
    display: flex;
    gap: var(--spacing-24);
    flex-direction: column;
    align-items: center;

    .text-content {
      .banner-header {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-12);
        padding-bottom: var(--spacing-24);
        .banner-title {
          @include font-heading-6;
        }
        .banner-subtitle {
          @include font-body-m-light;
        }
        .banner-subtitle,
        .banner-title {
          margin: 0;
        }
      }

      .benefits {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-16);
        .benefit-item {
          display: flex;
          gap: var(--spacing-12);
          .benefit-icon {
            display: flex;
            align-items: center;
            color: var(--color-brand-violet);
          }
          .benefit {
            display: flex;
            flex-direction: column;
            .benefit-title {
              @include font-body-m-bold;
            }
            .benefit-description {
              @include font-body-s-light;
            }
          }
        }
      }
    }
  }
}
</style>
